import {
  Box,
  Text,
  Heading,
  List,
  Stack,
  Columns,
  Column,
  ContentBlock,
} from 'braid-design-system';
import React from 'react';

import * as styles from './SellingPoints.css';

const SellingPoints = () => (
  <ContentBlock>
    <Box paddingX="gutter" paddingY="xlarge">
      <Columns space="large" collapseBelow="desktop" alignY="center">
        <Column>
          <Stack space="large">
            <Heading level="3">
              We want to be a partner in
              <br />
              helping you grow
            </Heading>
            <List>
              <Text>Target your job ad to the right people</Text>
              <Text>Maximise the return on your hiring investment</Text>
              <Text>Build real value through the right people</Text>
              <Text>Get local, hands-on customer support</Text>
            </List>
          </Stack>
        </Column>
        <Column>
          <Box className={styles.photoContainer} />
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
export default SellingPoints;
